/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetDashBoardResponse } from '../models/get-dash-board-response';

/**
 * API for counting pending workflow requests across different workflow types.
 */
@Injectable({ providedIn: 'root' })
export class DashBoardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getWorkFlowCount()` */
  static readonly GetWorkFlowCountPath = '/api/v1/dashboard';

  /**
   * get count of pending workflow requests.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkFlowCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkFlowCount$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetDashBoardResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      DashBoardService.GetWorkFlowCountPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('categoryId', params.categoryId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetDashBoardResponse>;
        })
      );
  }

  /**
   * get count of pending workflow requests.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkFlowCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkFlowCount(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;
    },
    context?: HttpContext
  ): Observable<GetDashBoardResponse> {
    return this.getWorkFlowCount$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetDashBoardResponse>): GetDashBoardResponse =>
          r.body
      )
    );
  }
}
